import { RequestActionType } from '@strata/react-chat';
import { WarningDialog } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';
import { useState } from 'react';
import { useNavigate } from 'react-router';

import { RequestSummarySection } from 'components/requests/dialogs/RequestSummarySection';
import { handleError } from 'services/Error';
import { type PayerRequestActionDialogProps } from 'services/interfaces';
import { AppRoutes } from 'services/routes';
import { usePostRequestActivityMutation } from 'store/api/payerRequestApi';

const Title = 'Reopen Request';

export const ReopenRequestDialog = ({
    onClose,
    payerId,
    requestDetails,
}: PayerRequestActionDialogProps) => {
    const [isReopening, setIsReopening] = useState(false);
    const navigate = useNavigate();
    const [postRequestActivity] = usePostRequestActivityMutation();
    return (
        <WarningDialog
            dialogTitle={`Confirm ${Title}`}
            width={600}
            isOpen
            secondaryButtonLabel="No, Return To Request Details"
            onSecondaryButtonClick={onClose}
            primaryButtonLabel="Yes, Reopen Request"
            primaryButtonDisabled={isReopening}
            onPrimaryButtonClick={() => {
                (async () => {
                    try {
                        setIsReopening(true);
                        const newRequestId = await postRequestActivity({
                            payerId,
                            requestId: requestDetails.requestId,
                            actionType: RequestActionType.REOPEN,
                        }).unwrap();

                        SuccessToast({ message: 'Request reopened successfully.' });
                        onClose();
                        navigate(AppRoutes.requestDetails(payerId, newRequestId));
                    } catch (err) {
                        handleError('Unable to reopen request. Please try again.', err as Error);
                    } finally {
                        setIsReopening(false);
                    }
                })();
            }}
            dialogContent={
                <>
                    <div className="margin__bottom--medium">
                        Are you sure you want to reopen this request?
                    </div>
                    <RequestSummarySection requestDetails={requestDetails} />
                </>
            }
        />
    );
};

ReopenRequestDialog.Title = Title;
